import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

import HNSColors from "../../../../ui library/HNSColors";
import sharedStyles from "../../styles/styles";
import { FILTER_OPTS } from "../../utils/strings";

const FilterDropdown = ({ chipData, handleSelection }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSelect = (value) => {
    handleSelection(value);
    handleClose();
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className="rounded-full text-xs capitalize"
        sx={{
          ...sharedStyles.menuDropdownButtonStyle,
          border: `1px solid ${HNSColors.secondary[500]}`,
          borderColor: HNSColors.secondary[500],
          color: HNSColors.secondary[500],
          "&:hover": { borderColor: HNSColors.secondary[400], color: HNSColors.secondary[400] },
        }}
        variant="outlined"
      >
        Filter by{" "}
        <KeyboardArrowDown className={`ml-2 transition-all ${open ? "rotate-180" : ""}`} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            marginTop: "8px",
          },
          "& .MuiList-root": {
            padding: 0,
            border: `1px solid ${HNSColors.secondary[500]}`,
            borderRadius: "8px",
          },
        }}
      >
        {FILTER_OPTS.map((option, idx) => {
          return (
            <MenuItem
              key={option.key}
              className="text-sm"
              sx={{
                borderRadius:
                  idx === 0 ? "8px 8px 0 0" : idx === FILTER_OPTS.length - 1 ? "0 0 8px 8px" : "0",
                backgroundColor: chipData.find((item) => item.key === option.key)
                  ? HNSColors.tertiary[900]
                  : "transparent",
                "&:hover": { backgroundColor: HNSColors.tertiary[800] },
              }}
              onClick={() => onSelect(option)}
            >
              {option.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default FilterDropdown;
